import { GatorProtectActionTypes } from './gatorProtect.types';

export const initialState = {
  loading: true,
  plans: [],
  planDetails: {
    planDetailsLoaded: false,
    auto_protect: true,
    summary: {
      malicious: 0,
      compromised: 0,
    },
    activity_detected: [],
  },
  planThreats: {
    loading: true,
    data: [],
  },
};

const gatorProtectReducer = (state = initialState, action) => {
  switch (action.type) {
    case GatorProtectActionTypes.GATOR_PROTECT_SET_PLAN_DETAILS_LOADED: {
      return {
        ...state,
        planDetails: {
          ...state.planDetails,
          planDetailsLoaded: action.payload,
        },
      };
    }
    case GatorProtectActionTypes.GATOR_PROTECT_PLAN_THREATS_LOADING: {
      return {
        ...state,
        planThreats: {
          ...state.planThreats,
          loading: action.payload,
        },
      };
    }
    case GatorProtectActionTypes.GATOR_PROTECT_PLAN_THREATS_SET: {
      return {
        ...state,
        planThreats: {
          ...state.planThreats,
          data: action.payload,
        },
      };
    }
    case GatorProtectActionTypes.GATOR_PROTECT_LOADING: {
      return {
        ...state,
        loading: action.payload,
      };
    }
    case GatorProtectActionTypes.GATOR_PROTECT_LIST_PLANS_REQUEST: {
      return {
        ...state,
        loading: true,
      };
    }
    case GatorProtectActionTypes.GATOR_PROTECT_LIST_PLANS_SUCCESS:
    case GatorProtectActionTypes.GATOR_PROTECT_LIST_PLANS_FAILURE: {
      return {
        ...state,
        loading: false,
      };
    }
    case GatorProtectActionTypes.GATOR_PROTECT_LIST_PLANS_SET: {
      return {
        ...state,
        plans: action.payload,
      };
    }
    case GatorProtectActionTypes.GATOR_PROTECT_GET_PLAN_DETAILS_REQUEST: {
      return {
        ...state,
        loading: true,
      };
    }
    case GatorProtectActionTypes.GATOR_PROTECT_GET_PLAN_DETAILS_SUCCESS:
    case GatorProtectActionTypes.GATOR_PROTECT_GET_PLAN_DETAILS_FAILURE: {
      return {
        ...state,
        loading: false,
      };
    }
    case GatorProtectActionTypes.GATOR_PROTECT_GET_PLAN_DETAILS_SET: {
      return {
        ...state,
        planDetails: {
          planDetailsLoaded: true,
          ...action.payload,
        },
      };
    }
    case GatorProtectActionTypes.GATOR_PROTECT_SET_AUTO_PROTECT: {
      return {
        ...state,
        planDetails: {
          ...state.planDetails,
          auto_protect: action.payload,
        },
      };
    }
    default:
      return state;
  }
};

export default gatorProtectReducer;
